import './IndicatorPreventInteraction.scss';
import React from 'react';
import Indicator from '../indicator/Indicator';

const componentInfo = {
  name: 'IndicatorPreventInteraction',
  className: 'indicator-prevent-interaction',
  useType: 'Content',
  componentType: 'Basic',
};
const IndicatorPreventInteraction = ({
  loading,
  extent,
}: {
  loading: boolean;
  extent: 'page' | 'page-content';
}) => {
  return (
    <div
      className={`${componentInfo.className} ${loading ? 'is-loading' : 'not-loading'
        } ${extent}-wide`}>
      <Indicator loading={loading}></Indicator>
    </div>
  );
};

export default IndicatorPreventInteraction;
